import axios from 'axios';
import { refreshToken } from './account';


const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  const companyId = localStorage.getItem('company_id');

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  if (companyId) {
    config.headers['CompanyId'] = companyId;
  }
  return config;
});

let isRefreshing = false;
let subscribers = [];
let latestToken = null;



const subscribeTokenRefresh = (cb) => {
  if (latestToken) {
    // ✅ Token already refreshed, call immediately
    cb(latestToken);
  } else {
    subscribers.push(cb);
  }
};

const onRefreshed = (token) => {
  latestToken = token;
  subscribers.forEach((cb) => cb(token));
  subscribers = [];
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error;
    if (response?.status === 401 || response?.status === 403) {
      console.log('API got 401 or 403', isRefreshing);
      if (!isRefreshing) {
        isRefreshing = true;
        latestToken = null; // Reset before refresh

        const refreshedToken = await refreshToken();

        try {
          onRefreshed(refreshedToken.token);
        } finally {
          isRefreshing = false;
        }
      }

      return new Promise((resolve) => {
        subscribeTokenRefresh((token) => {
          config.headers['Authorization'] = `Bearer ${token}`;
          resolve(api(config));
        });
      });
    }
    return Promise.reject(error);
  }
);

export default api










export const getAxios = (formData = false) => {
  const instance = axios.create({
    baseURL: '/api',
    withCredentials: true,
  });
  if (!formData) {
    instance.defaults.headers.common['content-type'] = 'application/json';
  }

  const accessToken = localStorage.getItem('access_token');
  if (accessToken) {
    instance.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
  }
  
  const companyId = localStorage.getItem('company_id');
  if (companyId) {
    instance.defaults.headers.common['CompanyId'] = companyId;
  }

  return instance;
};

export const tryGet = async (url, params) => {
  try {
    const response = await api.get(url, { params });
    return response;
  } catch (ex) {
    console.log('tryGet Error', ex);
  }
  // try {
  //   return await getAxios().get(url, body);
  // } catch (ex) {
  //   if (ex.response?.status === 401 || ex.response?.status === 403) {
  //     await refreshToken();
  //     return await getAxios().get(url, body);
  //   } else {
  //     throw ex;
  //   }
  // }
};

export const tryPost = async (url, body, formData = false) => {
  const response = await api.post(url, body);
  return response;
  // try {
  //   return await getAxios(formData).post(url, body);
  // } catch (ex) {
  //   if (ex.response?.status === 401 || ex.response?.status === 403) {
  //     await refreshToken();
  //     return await getAxios(formData).post(url, body);
  //   } else {
  //     throw ex;
  //   }
  // }
};

export const tryPut = async (url, body, formData = false) => {
  const response = await api.put(url, body);
  return response;
  // try {
  //   return await getAxios(formData).put(url, body);
  // } catch (ex) {
  //   if (ex.response?.status === 401 || ex.response?.status === 403) {
  //     await refreshToken();
  //     return await getAxios().put(url, body);
  //   } else {
  //     throw ex;
  //   }
  // }
};

export const tryDelete = async (url, body) => {
  const response = await api.delete(url, body);
  return response;
  // try {
  //   return await getAxios().delete(url, body);
  // } catch (ex) {
  //   if (ex.response?.status === 401 || ex.response?.status === 403) {
  //     await refreshToken();
  //     return await getAxios().delete(url, body);
  //   }
  // }
};

export { login, register, logout, getCurrentUser, refreshToken, sendEmailConfirmation, confirmEmail, updatePassword, forgotPassword, resetPassword } from './account';
export { getUsers, getUser, getUserEdit, updateUser, addUser, updateUserRoles, addUserRoles } from './users';
export { getRoles } from './roles';
export { getUserInvites, inviteUser, uninviteUser } from './userInvites';
export { getValves, getValve, getValveEdit, updateValve, addValve, importValves, exportValves, deleteValve, deleteValves } from './valves';
export { getValveExerciseSettings, getValveExerciseSetting, getValveExerciseSettingEdit, updateValveExerciseSetting, addValveExerciseSetting, importValveExerciseSettings, exportValveExerciseSettings } from './valveExerciseSettings';
export { getCompanies, getCompany, getCompanyEdit, updateCompany, addCompany, getCurrentCompany } from './companies';
export { getCompanyLogos, getCompanyLogo, getCompanyLogoEdit, updateCompanyLogo, addCompanyLogo, getCurrentCompanyLogo, deleteCompanyLogo } from './companyLogos';
export { getValveExercises, getValveExercise, getValveExerciseLatest, getValveExerciseEdit, updateValveExercise, addValveExercise, deleteValveExercise, exportAllValveExerciseResults, exportValveExerciseResults } from './valveExercises';
export { getAllDefaultValveExerciseSettings, getDefaultValveExerciseSettings, getDefaultValveExerciseSettingsEdit, updateDefaultValveExerciseSettings, addDefaultValveExerciseSettings, deleteDefaultValveExerciseSettings, getDefaultValveExerciseSettingsByValveId,getDefaultValveExerciseSettingsByValveSize } from './defaultValveExerciseSettings';
export { createOrder, captureOrder, createSubscription, cancelSubscription, getPayPalSubscription, getSubscriptionStatus, getPlans, getPlan, getClientId } from './payPal';
export { getHydrants, getHydrant, getHydrantEdit, updateHydrant, addHydrant, importHydrants, exportHydrants, deleteHydrant, deleteHydrants } from './hydrants';
export { getFireFlowTests, getFireFlowTest, getFireFlowTestLatest, getFireFlowTestEdit, updateFireFlowTest, addFireFlowTest, deleteFireFlowTest } from './fireFlowTests';
export { getFireFlowTestHydrants, getFireFlowTestHydrant, getFireFlowTestHydrantLatest, getFireFlowTestHydrantEdit, updateFireFlowTestHydrant, addFireFlowTestHydrant, deleteFireFlowTestHydrant } from './fireFlowTestHydrants';
export { getAllFireFlowReports, getFireFlowReports, getFireFlowReport, getFireFlowReportLatest, getFireFlowReportEdit, updateFireFlowReport, addFireFlowReport, deleteFireFlowReport } from './fireFlowReports';
export { getHydrantManufacturers, getHydrantManufacturer, getHydrantManufacturerEdit, updateHydrantManufacturer, addHydrantManufacturer, deleteHydrantManufacturer, deleteHydrantManufacturers } from './hydrantManufacturers';
export { getHydrantModels, getHydrantModel, getHydrantModelEdit, updateHydrantModel, addHydrantModel, deleteHydrantModel, deleteHydrantModels } from './hydrantModels';
export { getHydrantImages, getHydrantImage, getHydrantImageEdit, updateHydrantImage, addHydrantImage, deleteHydrantImage, deleteHydrantImages } from './hydrantImages';
export { getAllDefaultHydrantExerciseSettings, getDefaultHydrantExerciseSettings, getDefaultHydrantExerciseSettingsEdit, updateDefaultHydrantExerciseSettings, addDefaultHydrantExerciseSettings, deleteDefaultHydrantExerciseSettings, getDefaultHydrantExerciseSettingsByHydrantId,getDefaultHydrantExerciseSettingsByHydrantSize } from './defaultHydrantExerciseSettings';
export { getAllFlowDevices, getFlowDevice, updateFlowDevice, addFlowDevice, deleteFlowDevice } from './flowDevices';
export { getHydrantExerciseSettings, getHydrantExerciseSetting, getHydrantExerciseSettingEdit, updateHydrantExerciseSetting, addHydrantExerciseSetting, importHydrantExerciseSettings, exportHydrantExerciseSettings } from './hydrantExerciseSettings';
export { getHydrantExercises, getHydrantExercise, getHydrantExerciseLatest, getHydrantExerciseEdit, updateHydrantExercise, addHydrantExercise, deleteHydrantExercise } from './hydrantExercises';
export { exportExerciseResults } from './reports';
export { getHydrantFlushes, getHydrantFlush, getHydrantFlushLatest, updateHydrantFlush, addHydrantFlush, deleteHydrantFlush } from './hydrantFlushes';
export { getHydrantDeficiencies, getHydrantDeficienciesByHydrantId, getHydrantDeficiency, getHydrantDeficiencyEdit, updateHydrantDeficiency, addHydrantDeficiency, deleteHydrantDeficiency } from './hydrantDeficiencies';
export { getValveDeficiencies, getValveDeficienciesByValveId, getValveDeficiency, getValveDeficiencyEdit, updateValveDeficiency, addValveDeficiency, deleteValveDeficiency } from './valveDeficiencies';
export { createCheckout, updateSession, getSubscription, getStripeProducts } from './stripe';
export { getFeatureFlags } from './featureFlags';
